import React from 'react';
import PropTypes from 'prop-types';

export const ArrowIn = ({ width, height, ...props }) => (
  <svg
    data-icon='arrow-in'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M11 4v12.175l-5.6-5.6L4 12l8 8 8-8-1.4-1.425-5.6 5.6V4h-2Z'
    />
  </svg>
);

ArrowIn.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowIn.defaultProps = {
  width: 24,
  height: 24,
};
